import React from "react";
import PropTypes from "prop-types";
import {Form, Input, Modal, notification} from "antd";
import {handleFormErrorNotification} from "../utils/errors";


function handleSuccess(message, hide, callback, entityType) {
  notification.success({message: `${entityType} deleted`, description: message});
  hide();
  callback();
}

const DeleteModal = ({
                       entityType,
                       entityName,
                       entityHandle, // E.g. {brandId}
                       onDelete,
                       // form: {getFieldDecorator, isFieldTouched, getFieldError, setFields, validateFields},
                       form,
                       visible,
                       entityDeleting,
                       hideDeleteFormModal,
                       deleteEntity,
                       includeHistoryMessage
                     }) => {
  const sDeleteXx = `Delete ${entityType}`;
  const {getFieldDecorator, isFieldTouched, getFieldError, setFields, validateFields} = form;
  return (<Modal title={sDeleteXx}
                 visible={visible}
                 okText="Delete"
                 okButtonProps={{
                   disabled: !!getFieldError('reason') || !isFieldTouched('reason'),
                   loading: entityDeleting
                 }}
                 onOk={() => validateFields((err, values) => {
                   if (err) return;
                   deleteEntity({...values, ...entityHandle})
                     .then(
                       () => handleSuccess(`${entityType} ${entityName} is now deleted`, hideDeleteFormModal, onDelete, entityType),
                       err => handleFormErrorNotification(err, values, setFields, notification)
                     );
                 })}
                 onCancel={hideDeleteFormModal}
  >
    <Form onSubmit={e => e.preventDefault()}>
      <Form.Item label={entityType}>
        {entityName}
      </Form.Item>
      <Form.Item label="Reason">
        {getFieldDecorator('reason', {
          initialValue: '',
          rules: [{required: true}],
        })(
          <Input autoFocus/>
        )}
      </Form.Item>
    </Form>
    {includeHistoryMessage && <i>Note that deleting a {entityType} does not change its history</i>}
  </Modal>)
};

DeleteModal.propTypes = {
  entityType: PropTypes.string.isRequired,
  entityName: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  /* state */
  visible: PropTypes.bool.isRequired,
  entityHandle: PropTypes.object.isRequired,
  entityDeleting: PropTypes.bool.isRequired,
  /* actions */
  hideDeleteFormModal: PropTypes.func.isRequired,
  deleteEntity: PropTypes.func.isRequired,
  includeHistoryMessage: PropTypes.bool,
};

const DeleteFormModal = Form.create({})(DeleteModal);
export default DeleteFormModal;



// WEBPACK FOOTER //
// ./src/common/DeleteFormModal.js